<app-subscriptions-catgirl-offer
  [subscriptionOffers]="subscriptionOffers"
  [isModal]="true"
  (openPolicy)="openPolicyModal()"
  (openTerms)="openTermsOfUseModal()"
  (onPurchase)="purchase($event)"
  (close)="close()"
></app-subscriptions-catgirl-offer>
